import { DettaglioItem, Formatter, useApi } from 'gf-ui'
import { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { apiConf } from '../../api/apiConf'

const DatiMedicoReferente = () => {
  const user = useSelector( state => state.user )    
  const shouldInit = useRef(true)
  const [datiUtente, setDatiUtente] = useState(null)  
  const _apiConf = useApi(apiConf)

  useEffect(() => {
    if (shouldInit.current && _apiConf) {
      shouldInit.current = false
      _apiConf.fnDatiUtente(res => {
        let _datiUtente = res.datiUtente
        _datiUtente.TIPOLOGIA = _datiUtente.UTENTI_WEB_TIPI.find(t =>
          Formatter.getBoolean(t.FLG_ASSEGNATA)
        )
        setDatiUtente(res.datiUtente)
      })
    }
  }, [_apiConf])

  return (
    datiUtente && (
      <div className='bg-light m-4 p-4 border rounded'>
        <h6 className='text-uppercase text-center mb-4'>
          Dati del medico referente
        </h6>
        <Row>
					<Col xs={12} md={6} lg={3}>
            <DettaglioItem label='Username' value={datiUtente.USERNAME} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem label='Nominativo' value={datiUtente.NOMINATIVO} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem label='Codice fiscale' value={user.codiceFiscale} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem
              label='Email'
              value={datiUtente.EMAIL || user.EMAIL}
            />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem label='Telefono' value={datiUtente.TELEFONO} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem
              label='Tipologia'
              value={datiUtente.TIPOLOGIA && datiUtente.TIPOLOGIA.DESCRIZIONE}
            />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem
              label='Disciplina'
              value={datiUtente.SPECIALISTICA}
            />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem label='ASL' value={datiUtente.ASL} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem label='Distretto' value={datiUtente.DISTRETTO} />
          </Col>
          <Col xs={12} md={6} lg={3}>
            <DettaglioItem
              label='Struttura Sanitaria'
              value={datiUtente.STRUTTURA_SANITARIA}
            />
          </Col>
        </Row>
      </div>
    )
  )
}

export default DatiMedicoReferente
